import { apiCall } from '../../../services/apiUtil';

export const cricketGameAPI = {
  create: async (matchData) => {
    const payload = {
      eventId: matchData.eventId,
      // Save team data as playerA/playerB so they persist in participant_a/b_info
      playerA: matchData.playerA || (matchData.teamAName ? { type: 'team', name: matchData.teamAName, players: matchData.teamAPlayers || [] } : undefined),
      playerB: matchData.playerB || (matchData.teamBName ? { type: 'team', name: matchData.teamBName, players: matchData.teamBPlayers || [] } : undefined),
      teamAName: matchData.teamAName,
      teamBName: matchData.teamBName,
      teamAId: matchData.teamAId || null,
      teamBId: matchData.teamBId || null,
      teamAPlayers: matchData.teamAPlayers,
      teamBPlayers: matchData.teamBPlayers,
      oversPerInning: matchData.oversPerInning || 20,
      oversPerBowler: matchData.oversPerBowler || 4,
      inningsPerTeam: matchData.inningsPerTeam || 1,
      maxPlayersPerTeam: matchData.maxPlayersPerTeam || 11,
      tossWinner: matchData.tossWinner,
      tossChoice: matchData.tossChoice,
      currentStrikerId: matchData.currentStrikerId || null,
      currentNonStrikerId: matchData.currentNonStrikerId || null,
      currentBowlerId: matchData.currentBowlerId || null,
    };

    return apiCall('/games', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  getById: async (id) => {
    return apiCall(`/games/${id}`);
  },

  getByEventId: async (eventId) => {
    return apiCall(`/games/event/${eventId}`);
  },

  update: async (matchId, updateData) => {
    return apiCall(`/games/${matchId}`, {
      method: 'PATCH',
      body: JSON.stringify(updateData),
    });
  },

  recordBall: async (matchId, ballData) => {
    const payload = {
      inningsNumber: ballData.inningsNumber,
      overNumber: ballData.overNumber,
      ballInOver: ballData.ballInOver,
      bowlerId: ballData.bowlerId,
      strikerId: ballData.strikerId,
      nonStrikerId: ballData.nonStrikerId,
      isWide: ballData.isWide || false,
      isNoBall: ballData.isNoBall || false,
      isBye: ballData.isBye || false,
      isLegBye: ballData.isLegBye || false,
      isLegalDelivery: ballData.isLegalDelivery !== false,
      strikerRuns: ballData.strikerRuns || 0,
      extraRuns: ballData.extraRuns || 0,
      isFour: ballData.isFour || false,
      isSix: ballData.isSix || false,
      isWicket: ballData.isWicket || false,
      wicketBatsmanId: ballData.wicketBatsmanId || null,
      dismissalType: ballData.dismissalType || null,
      fielderId: ballData.fielderId || null,
      newStrikerId: ballData.newStrikerId,
      newNonStrikerId: ballData.newNonStrikerId,
      newBowlerId: ballData.newBowlerId,
      lastOverBowlerId: ballData.lastOverBowlerId,
    };

    return apiCall(`/games/${matchId}/cricket/balls`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  undoLastBall: async (matchId) => {
    return apiCall(`/games/${matchId}/cricket/balls/last`, {
      method: 'DELETE',
    });
  },

  /**
   * Record a between-ball player change: a bowler taken off mid-over, a batsman
   * retiring hurt, or a retired batsman coming back out. These have no ball to
   * ride on, so they go to their own log rather than through recordBall.
   */
  recordPlayerEvent: async (matchId, eventData) => {
    const payload = {
      eventType: eventData.eventType,
      playerId: eventData.playerId,
      reason: eventData.reason,
    };
    if (eventData.replacementPlayerId) payload.replacementPlayerId = eventData.replacementPlayerId;
    if (eventData.reasonNote) payload.reasonNote = eventData.reasonNote;
    if (eventData.inningsNumber != null) payload.inningsNumber = eventData.inningsNumber;
    if (eventData.overNumber != null) payload.overNumber = eventData.overNumber;
    if (eventData.ballInOver != null) payload.ballInOver = eventData.ballInOver;

    return apiCall(`/games/${matchId}/cricket/player-events`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  updateState: async (matchId, stateData) => {
    return apiCall(`/games/${matchId}/cricket/match-state`, {
      method: 'PATCH',
      body: JSON.stringify(stateData),
    });
  },

  complete: async (matchId, completionData) => {
    return apiCall(`/games/${matchId}/cricket/match-complete`, {
      method: 'POST',
      body: JSON.stringify(completionData),
    });
  },

  pause: async (gameId, { reason, durationMinutes }) => {
    return apiCall(`/games/${gameId}/pause`, {
      method: 'POST',
      body: JSON.stringify({ reason, durationMinutes }),
    });
  },

  resume: async (gameId) => {
    return apiCall(`/games/${gameId}/resume`, { method: 'POST' });
  },
};

export default cricketGameAPI;
